<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando seguridad...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="!flagLoaded" style="height: 100vh;"></div>

<div *ngIf="flagLoaded">
<app-page-header icon="shield" title="Seguridad" subtitle="Gestión de usuarios, roles y permisos del sistema"></app-page-header>

<div class="seguridad-area seguridad-animate-in">
  <div class="container">
    <p class="intro">
      Seleccione una opción para administrar la seguridad del sistema.
    </p>

    <mat-form-field class="buscador" appearance="outline">
      <mat-label>Buscar opción</mat-label>
      <span class="material-icons" matPrefix>search</span>
      <input
        matInput
        [ngModel]="termino"
        (ngModelChange)="aplicarFiltro($event)"
        placeholder="Usuarios, roles, permisos..."
        autocomplete="off"
      />
    </mat-form-field>

    <div class="cards-grid">
      <div
        class="seguridad-card"
        *ngFor="let comp of componentesFiltrados"
        (click)="entrar(comp)"
      >
        <div class="seguridad-card__icon">
          <span class="material-icons">{{ comp.icono }}</span>
        </div>
        <h3>{{ comp.titulo }}</h3>
        <p>{{ comp.descripcion }}</p>
        <a class="link-btn">Acceder</a>
      </div>
    </div>

    <div class="sin-resultados" *ngIf="componentesFiltrados.length === 0">
      No se encontraron opciones para "{{ termino }}".
    </div>
  </div>
</div>
</div>
